import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { debounceTime, fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProductsService } from '../../../services/products.service';
import { EventEmitterService } from '../../../services/event-emitter.service';
import { ProductPopupComponent } from '../../../modals/product-popup/product-popup.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeletePopupComponent } from '../../../modals/delete-popup/delete-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { AccountTypes } from '../../../models/account_types';

@Component({
  standalone: false,
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrl: './products.component.scss',
})
export class ProductsComponent implements OnInit, AfterViewInit {
  user;
  @ViewChild('searchInput') searchInput: ElementRef;
  search = '';
  products = [];
  page = 1;
  pageSize = 10;
  totalItems = 0;
  totalPages = 1;
  loading = false;
  destoryRef = inject(DestroyRef);
  columns = [
    { header: 'name', field: 'name' },
    { header: 'description', field: 'description' },
    { header: 'image', field: 'imageURL', type: 'image' },
    { header: 'price', field: 'priceString' },
    { header: 'category', field: 'category' },
    { header: 'published', field: 'publishedString' },
  ];

  constructor(
    private productsService: ProductsService,
    private modalService: BsModalService,
    private authenticationService: AuthenticationService,
    public eventEmitterService: EventEmitterService,
    private translateService: TranslateService,
  ) {
    this.eventEmitterService.invokeEvent
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe((event) => {
        if (event == 'call-all-products') {
          this.resetPagination();
          this.getAllProducts();
        }
      });
  }

  async ngOnInit() {
    await this.getUser();
    this.setupColumns();
    this.resetPagination();
    this.getAllProducts();
  }

  ngAfterViewInit(): void {
    this.setupSearch();
  }

  async getUser() {
    this.user = await this.authenticationService.getUserFromToken();
  }

  setupColumns() {
    if (this.user.user.business.type == AccountTypes.Delivery) {
      this.columns = [
        { header: 'business', field: 'businessName' },
        { header: 'name', field: 'name' },
        { header: 'description', field: 'description' },
        { header: 'image', field: 'imageURL', type: 'image' },
        { header: 'price', field: 'priceString' },
        { header: 'category', field: 'category' },
        { header: 'published', field: 'publishedString' },
      ];
    }
  }

  resetPagination() {
    this.products = [];
    this.page = 1;
    this.pageSize = 10;
    this.totalItems = 0;
    this.totalPages = 1;
  }

  getAllProducts() {
    if (this.loading) {
      return;
    }
    this.loading = true;

    const apiData: any = {
      page: this.page,
      pageSize: this.pageSize,
    };

    if (this.search && this.search.trim().length > 0) {
      apiData.search = this.search;
    }
    this.productsService.getAllProducts(apiData).subscribe(
      (response: any) => {
        this.loading = false;

        this.products = response.items;
        this.page = response.page;
        this.pageSize = response.pageSize;
        this.totalItems = response.totalItems;
        this.totalPages = response.totalPages;

        this.products.forEach((item) => {
          item.businessName = item.business.name;
          let noString = this.translateService.instant('no');
          let yesString = this.translateService.instant('yes');
          item.publishedString = noString;
          if (item.published == 'true') {
            item.publishedString = yesString;
          }
          item.priceString = item.price;
        });

        console.log('this.products:');
        console.log(this.products);
      },
      (error) => {
        console.log('error:');
        console.log(error);
        this.loading = false;
      },
    );
  }

  setupSearch() {
    fromEvent(this.searchInput.nativeElement, 'input')
      .pipe(debounceTime(3000))
      .subscribe((event: Event) => {
        this.resetPagination();
        this.getAllProducts();
      });
  }

  setSearch(event: any) {
    this.search = event.target.value;
  }

  onPageChange(event: { page: number; pageSize: number }) {
    this.page = event.page;
    this.pageSize = event.pageSize;
    this.getAllProducts();
  }

  addProduct() {
    this.modalService.show(ProductPopupComponent, {
      initialState: {
        title: 'new-product',
        type: 'new-product',
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  editProduct(product) {
    this.modalService.show(ProductPopupComponent, {
      initialState: {
        title: 'edit-product',
        type: 'edit-product',
        product: product,
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  deleteProductPopup(id) {
    this.modalService.show(DeletePopupComponent, {
      initialState: {
        title: 'delete-product',
        text: 'delete-product-text',
        id: id,
        onButtonClick: this.deleteProduct.bind(this),
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  async deleteProduct(id): Promise<void> {
    console.log('delete product id:');
    console.log(id);
    return new Promise((resolve, reject) => {
      this.productsService.deleteProduct(id).subscribe(
        (response) => {
          console.log('response:');
          console.log(response);
          this.eventEmitterService.callAllProducts();
          resolve();
        },
        (error) => {
          console.log('error:');
          console.log(error);
          reject();
        },
      );
    });
  }
}
